const PHRASES = [
  "Bracelets for a Brighter You",
  "Handcrafted in Small Batches",
  "Heena in HESHAURA",
  "Grace in Every Detail",
  "More Than a Bracelet. A Feeling.",
  "Your Story, Around Your Wrist",
];

// One slow editorial marquee — a quiet, continuous brand line.
export const EditorialMarquee = () => (
  <section
    aria-hidden="true"
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-brand-gold/25 bg-brand-champagne/70 py-5"
  >
    <div className="animate-marquee flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center">
          {PHRASES.map((phrase, i) => (
            <span key={i} className="flex items-center">
              <span
                className={`whitespace-nowrap px-8 font-serif text-2xl sm:text-3xl ${
                  i % 2 === 0 ? "italic text-brand-gold" : "font-medium text-brand-charcoal/85"
                }`}
              >
                {phrase}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-brand-gold/50" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
